import { TQuizId } from '@bridebook/web/components/quiz/types';

export type TQuizNameAnalytics = TQuizId | 'supplierMatching' | 'supplierMatching_shortlist';

export const analyticsCategory = 'Supplier search';
